import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

// Translate
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as spanish } from './i18n/es';

// Model
import { ServiceType } from '../../../models/service-type.model';
import { TiposServicioService } from 'app/main/tiposservicio/tiposservicio.service';
import { GLOBAL } from '../../../global/global';

@Component({
    selector: 'app-tiposservicio-add',
    templateUrl: './tiposservicio-add.component.html',
    styleUrls: ['./tiposservicio-add.component.scss'],
    providers: [TiposServicioService]
})
export class TiposServicioAddComponent implements OnInit, OnDestroy
{
    public form: FormGroup;
    public dataTipoSevicio: ServiceType;
    private titleModule: string;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param _formBuilder
     * @param _fuseTranslationLoaderService
     * @param _route
     * @param _router
     * @param _tiposservicioService
     * @param _location
     * @param _matSnackBar
     */
    constructor(
        private _formBuilder: FormBuilder,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _route: ActivatedRoute,
        private _router: Router,
        private _tiposservicioService: TiposServicioService,
        private _location: Location,
        private _matSnackBar: MatSnackBar
    )
    {
        // Set the private defaults
        this._fuseTranslationLoaderService.loadTranslations(spanish);
        this._unsubscribeAll = new Subject();
        this.titleModule = 'Tipo de servicio';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------


    /**
     * On init
     */
    ngOnInit(): void {
        this.dataTipoSevicio = new ServiceType();
        // Reactive Form
        this.form = this.createDataForm();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create product form
     *
     * @returns {FormGroup}
     */
    createDataForm(): FormGroup
    {
        return this._formBuilder.group({
            id              : [this.dataTipoSevicio.id],
            name            : [this.dataTipoSevicio.name, [Validators.required]],
            active          : [this.dataTipoSevicio.active]
        });

    }

    saveTipoServicio(): void {
        this._tiposservicioService.create(this.form.value)
            .then(() => {
                    this._matSnackBar.open(this.titleModule + ' agregado', 'OK', {
                        verticalPosition: 'top',
                        duration        : 2000
                    });

                    this._router.navigate(['/tiposservicio']);
            })
            .catch((error: any) => {
                this._matSnackBar.open('Error en actualización', 'Error', {
                    verticalPosition: 'top',
                    duration        : 2000
                });
            });
    }
}
